<template>
    <section class="recommend-container wrapper"
        style=" display: flex; justify-content: center; margin-bottom: 20px; max-width: 1680px;">
        <div class="illust-box" style="width: 96%; display: flex;justify-content: center;">
            <div>
                <h2 class="illust-title">{{ illust_title }}</h2>
                <div class="illust-content" style="display: flex">
                    <div class="muuri" style="">
                        <div :class="illust_title" v-for="(item, index) in imageData" :key="item.picture_id">
                            <div class="item-content">
                                <ImageCard :imageInfo="item" :index="index"></ImageCard>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// import muuri from "muuri"
import ImageCard from './ImageCard.vue';

export default {
    props: {
        illust_title: {
            type: String,
            default: ""
        },
        imageData: {
            type: Array,
            default: [{
                "picture_id": "",
                "title": "",
                "width": 2438,
                "height": 4093,
                "regular_url": "",
                "original_url": "",
                "page_total": 1,
                "status": 5,
                "type": 0,
                "like_total": 0,
                "comment_total": 0,
                "tags": "",
                "created_at": ""
            }]
        }
    },
    components: {
        ImageCard,
    },
    mounted() {
    },
}
</script>

<style scoped>
.muuri {
    /* position: relative;
    left: 0; */
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 10px;
}

.item1 {
    display: block;
    position: absolute;

    margin: 10px;
    z-index: 1;
    color: #fff;
}

.item1.muuri-item-dragging {
    z-index: 3;
}

.item1.muuri-item-releasing {
    z-index: 2;
}

.item1.muuri-item-hidden {
    z-index: 0;
}

.item-content {
    position: relative;
    width: 100%;
    height: 100%;
    opacity: 0;
    animation: mymove 0.6s ease-in forwards;
}

@media screen and (max-width: 1400px) {
    .muuri {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media screen and (max-width: 1060px) {
    .muuri {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media screen and (max-width: 850px) {
    .muuri {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 560px) {
    .muuri {
        grid-template-columns: repeat(1, 1fr);
    }
}

@keyframes mymove {
    10% {
        opacity: 0.1;
    }

    50% {
        opacity: 0.5;
    }

    60% {
        opacity: 0.6;
    }

    90% {
        opacity: 0.9;
    }

    100% {
        opacity: 1;
    }
}
</style>